(ns teamoesterreich.user-mode.landing.app-panel.warning-card
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent.core :as r]
    [teamoesterreich.firebase.fb-warning :as fb-warning]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    ))



(defn is-online [!locations !warnings]
  (let [count-warnings (fb-warning/count-all-actual-location-warnings)]
    [mui/paper {:class   "app-panel clickable"
                :style   {:textAlign "left" :cursor "hand"}
                :onClick #(a/set-page :warning-overview)
                }
     [:div {:class "app-panel-img"}
      [:img {:src "/custom/img/warnen_bunt.png" :alt "t-man"}]
      ]
     [:div {:class "app-panel-content"}
      [:div {:class "app-panel-title"}
       (txt/transl "Ich werde gewarnt")]
      [:p {:class "warn"} (if (= count-warnings 1)
                            (txt/transl "Du hast eine aktuelle Warnung.")
                            (clojure.string/replace (txt/transl "Du hast __CNT__ aktuelle Warnungen!") "__CNT__" count-warnings))]]
     ]))

(defn login []
  [mui/paper {:class   "app-panel clickable"
              :style   {:textAlign "left" :cursor "hand"}
              :onClick #(a/set-page :warning-overview)
              }
   [:div {:class "app-panel-img"}
    [:img {:src "/custom/img/warnen_bunt.png" :alt "t-man"}]
    ]

   [:div {:class "app-panel-content"}
    [:div {:class "app-panel-title"} (txt/transl "Ich will gewarnt werden ....")]
    ]
   ])

(defn get-it []
  (let [!actual-user (r/cursor store/app-state [:actual-user])
        !locations (r/cursor store/app-state [:locations])
        !warnings (r/cursor store/app-state [:warnings])]
    (if (:tom-id @!actual-user)
      (is-online !locations !warnings)
      (login)
      )))
